import React, { useEffect, useState } from 'react'
import { Button, Tag } from 'primereact';


import Card from '../../../../Base/Components/Card/Card'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';

import { getInventarioGeneralQC } from '../../../../API/Produccion/QuimicosColorantes/InventarioGeneralReques';

import { ArchivosExcelService } from '../../../../Base/Services/ArchivosService';
import { colorCotton, colorSintetico } from '../../../../Styles/Colors';


export const InventarioGeneralQCScreen = () => {


    const [inventario, setInventario] = useState([]);
    const [loading, setLoading] = useState(false)


    const getInfo = async () => {
        setLoading(true)
        const a = await getInventarioGeneralQC();
        setInventario(a);
        setLoading(false);
    }

    const categoryTemplate = (rowData) => {
        switch (rowData.NombreTipo) {
            case 'Quimicos':
                return <Tag severity='danger' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorCotton }}/>
                break;
            case 'Colorantes':
                return <Tag severity='info' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorSintetico }}/>
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: '#ffc605' }} />
                break;
        
            default:
                return <div>{rowData.NombreTipo}</div>
                break;
        }
    }

    const columns = [
        {
            header: 'Codigo Producto',
            field: 'CodigoProducto',
            className: 'small'
        },
        {
            header: 'Nombre Tipo',
            field: 'NombreTipo',
            className: 'Xsmall',
            Format: 'Template',
            body: categoryTemplate
        },
        {
            header: 'Producto',
            field: 'NombreProducto',
            // className: 'XXlarge',
            flex: 1,
            Sumary: 'count',
            minWidth: 200
        },
        {
            header: 'Inicial',
            field: 'Inicial',
            Format: 'Decimal',
            className: 'medium',
            Sumary: 'sum'
        },
        {
            header: 'Ingreso',
            field: 'Ingreso',
            Format: 'Decimal',
            className: 'medium',
            Sumary: 'sum'
        },
        {
            header: 'InvAlmacen',
            field: 'InvAlmacen',
            Format: 'Decimal',
            className: 'medium',
            Sumary: 'sum'
        },
        {
            header: 'InvCocina',
            field: 'InvCocina',
            Format: 'Decimal',
            className: 'medium',
            Sumary: 'sum'
        },
        {
            header: 'Consumo',
            field: 'Salida',
            Format: 'Decimal',
            className: 'medium',
            Sumary: 'sum'
        },
        {
            header: 'Inventario',
            field: 'Inventario',
            Format: 'Decimal',
            className: 'medium',
            Sumary: 'sum'
        },

    ];

    const table = {
        Columns: columns,
        Data: inventario,
        loading: loading
    }

    const exportarExcel = () => {
        const t = inventario.map(i => {
            return {
                "Codigo Producto": i.CodigoProducto,
                "Nombre Tipo": i.NombreTipo,
                Producto: i.NombreProducto,
                Inicial: i.Inicial,
                Ingreso: i.Ingreso,
                InvAlmacen: i.InvAlmacen,
                InvCocina: i.InvCocina,
                Consumo: i.Salida,
                Inventario: i.Inventario
            }
        })
        ArchivosExcelService(t, 'Inventario General QC ')
    }

    useEffect(() => {
        window.document.title = 'PPF • Inventario QC';
        getInfo()
    }, [])



    return (
        <div className='p-3'>
            <Card
                titulo={<div className='d-flex'>
                    <h3>Inventario General</h3>
                    <div className='mx-2'>
                        <Button icon={'pi pi-search'} className='p-button-info mx-2' onClick={e => getInfo()} />
                        <Button icon={'pi pi-file-excel'} className='p-button-success' onClick={e => exportarExcel()} />
                    </div>
                </div>}
                contenido={<div className='p-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}

export default InventarioGeneralQCScreen
